import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { KeycloakTokenParsed, KeycloakLogoutOptions  } from "keycloak-js";

import { userNameObject, userProfileObject } from "../../lib/types";
import { getProfileObject } from "../../lib/utils";
//import { longLogoSrc } from "../../constants/constants";

import AuthService from '../../services/AuthService';

import './usernavprofile.scss';

const Navigationbar = () => {
    const [user, setUser] = useState<any>();
    const [profileObject, setProfileObject] = useState<userProfileObject>();

    useEffect(() => {
        const user = AuthService.getUser();
        const cObj = getProfileObject(user as userNameObject);

        setUser(user);
        setProfileObject(cObj);
    }, []);

    const { t, i18n } = useTranslation();

    const logout = () => {
        AuthService.doLogout({redirectUri: window.location.origin});
    }

    const getPopover = () => {
        return <Popover id="user-nav-profile-popover" className="user-nav-profile-popover">
            <Popover.Header className="user-nav-profile-popover-header">
                {user?.name}
            </Popover.Header>
            <button className="user-nav-profile-popover-logout" onClick={logout}>
                {t('auth.logout')}
            </button>
        </Popover>;
    }

    return (
        <OverlayTrigger trigger={"click"} placement={"bottom"} overlay={getPopover()} rootClose={true}>
            <div className="user-nav-profile-root" style={{ backgroundColor: profileObject?.bgColor, color: profileObject?.txtColor }}>
                <div className="user-nav-profile-initials">
                    {profileObject?.initials}
                </div>
            </div>
        </OverlayTrigger>
    );
};

export default Navigationbar;